export const cardCancellation = {
    usePrepaidCancellationFlow: true,
};
